var map = {
	"./bingo-online.md": 6156,
	"./calcolapizza.md": 5306,
	"./covid-io-quando-mi-vaccino.md": 804,
	"./privacy/tombola-online-de.md": 9121,
	"./privacy/tombola-online-en.md": 9989,
	"./privacy/tombola-online-es.md": 4965,
	"./privacy/tombola-online-fr.md": 1012,
	"./privacy/tombola-online-it.md": 4015,
	"./privacy/tombola-online-pt.md": 6760,
	"./privacy/tombola-online-ro.md": 2657,
	"./privacy/tombola-online-ru.md": 3348,
	"./privacy/tombola-online-tr.md": 4536,
	"./roll-the-dice.md": 3232,
	"./terms-and-conditions/tombola-online-de.md": 9388,
	"./terms-and-conditions/tombola-online-en.md": 1824,
	"./terms-and-conditions/tombola-online-es.md": 1683,
	"./terms-and-conditions/tombola-online-fr.md": 9382,
	"./terms-and-conditions/tombola-online-it.md": 1835,
	"./terms-and-conditions/tombola-online-pt.md": 562,
	"./terms-and-conditions/tombola-online-ro.md": 2072,
	"./terms-and-conditions/tombola-online-ru.md": 3817,
	"./terms-and-conditions/tombola-online-tr.md": 6903,
	"./tombola-online.md": 9048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9286;